export default {
	name: 'landing',
	created() {
		this.load()
	},
	methods: {
		async load () {
			const query = this.$route.query
			const { redirect } = query
			await this.$router.push(redirect)
			// await this.$api.account.getWxInfo({ redirect })
		}
	},
	render (h) {
		return h('div')
	}
}
